import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './InvitationLetterInfo.css';

const InvitationLetterInfo = () => {
  return (
    <>
      <Navbar />

      <main className="invitation-container">
        {/* Page Title */}
        <h1 className="invitation-title">Invitation Letter</h1>

        {/* Information Section */}
        <div className="invitation-content">
          <p>
            Foreign Delegates requiring an invitation letter for visa purposes may 
            <strong> download the same after completing the registration payment process</strong>.
          </p>
          <p>
            Indian delegates requiring an invitation letter may mail the STIS team at 
            <a href="mailto:stis.mte@iisc.ac.in"> stis.mte@iisc.ac.in</a>.
          </p>
          <p>
            Foreign delegates requiring assistance for the visa process may contact 
            the STIS team with full details of their passport.
          </p>

          {/* Download Button */}
          <div className="download-section">
  <a 
    href="assets/Letter-From-MEA.pdf" 
    target="_blank" 
    rel="noopener noreferrer"
    className="download-btn" 
    style={{ color: "white" }}
  >
    Letter from MEA
  </a>
</div>

        </div>

        {/* Tutorial Video Section */}
        <section className="tutorial-video-section">
          {/* <h2 className="tutorial-title">How to Get an Invitation Letter</h2> */}
          <div className="video-wrapper">
            {/* <video controls>
              <source src="/stis2025/assets/Letter.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video> */}
          </div>
        </section>
      </main>
      <br/>
      <br/>
      <br/>

      <Footer />
    </>
  );
};

export default InvitationLetterInfo;
